import { Form, Input, InputNumber, Popconfirm, Table, Typography } from "antd";
import TableAntd from "components/elements/Table";
import TableAntdFix from "components/elements/Table/TableFixPage";
import { FormInput, FormInputNumber } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { t } from "i18next";
import { useCallback, useMemo, useState } from "react";
// import "./GroupCalculationFormTable.css"

const GroupCalculationFormTable = ({
    form = () => { },
    EditableCell = () => { },
    column = [],
    dataSource = [],
    isLoading = false,
    onFinish = () => { },
    pagination = {},
    onPageChange = () => { }
}) => {

    // const pagedData = useMemo(() =>
    //     dataSource?.slice?.(
    //         (pagination.current - 1) * pagination.pageSize,
    //         pagination.current * pagination.pageSize
    //     ),
    //     [dataSource, pagination.current, pagination.pageSize]
    // );
    const components = useMemo(() => ({
        body: { cell: EditableCell },
    }), [EditableCell]);
    return (
        <FormAntd
            form={form}
            component={false}
            onFinish={onFinish}
        >
            <TableAntdFix
                size="small"
                sticky={{ offsetHeader: 64, offsetSummary: 64 }}
                components={components}
                bordered
                pagination={{
                    ...pagination,
                }}
                // pagination={{
                //     current: pagination.current,
                //     pageSize: pagination.pageSize,
                //     total: pagination.total,
                //     onChange: (page, pageSize) => onPageChange({ current: page, pageSize }),
                // }}
                dataSource={dataSource}
                columns={column}
                onChange={onPageChange}
                scroll={{ x: "100vh" }}
                loading={isLoading}
            />
        </FormAntd>
    )
}
export default GroupCalculationFormTable